import {
  Box,
  Button,
  InputCheckBox,
  SelectOptionGroups,
  Spinner,
  Text,
} from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import Select from 'modules/core/components/Select'
import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { PostFormValues } from 'modules/posts/components/ManagePost/types'

interface Props {
  isSubmitting: boolean
  onSubmit: () => void
  onCloseModal: () => void
  groupOptions: SelectOptionGroups
}

const PublishModal = ({ isSubmitting, onSubmit, onCloseModal, groupOptions }: Props) => {
  const form = useFormContext<PostFormValues>()

  return (
    <Modal
      illustration="network-group"
      title={i18n.t('posts.communities.modal.title')}
      description={i18n.t('posts.communities.modal.description')}
      onClose={onCloseModal}
      onSubmit={onSubmit}
      footer={
        <Button disabled={isSubmitting} submit>
          {i18n.t('posts.communities.modal.action')}
        </Button>
      }
    >
      {isSubmitting && (
        <Box alignItems="center" justifyContent="center">
          <Spinner />
        </Box>
      )}
      {!isSubmitting && (
        <>
          <Box paddingBottom="s16">
            <Select
              none={groupOptions.length === 0 ? i18n.t('common.none') : undefined}
              value={String(form.values.postGroupId)}
              label={i18n.t('posts.new.labels.community')}
              options={groupOptions}
              onChange={(postsGroupId) =>
                form.setValues({ ...form.values, postGroupId: Number(postsGroupId) })
              }
              mandatory
            />
          </Box>
          <Box
            component="label"
            flexDirection="row"
            flexGrow
            gap="s4"
            alignItems="center"
            justifyContent="flexStart"
            paddingY="s16"
          >
            <InputCheckBox
              onClick={() =>
                form.setValues({
                  ...form.values,
                  allowCommentsAndReactions: !form.values.allowCommentsAndReactions,
                })
              }
              checked={form.values.allowCommentsAndReactions}
            />
            <Text.Normal>{i18n.t('posts.communities.modal.comments')}</Text.Normal>
          </Box>
          <Box
            component="label"
            flexDirection="row"
            flexGrow
            gap="s4"
            alignItems="center"
            justifyContent="flexStart"
          >
            <InputCheckBox
              onClick={() =>
                form.setValues({
                  ...form.values,
                  sendNotifications: !form.values.sendNotifications,
                })
              }
              checked={form.values.sendNotifications}
            />
            <Text.Normal color="grey800">{i18n.t('posts.communities.modal.email')}</Text.Normal>
          </Box>
        </>
      )}
    </Modal>
  )
}

export default observer(PublishModal)
